export const STUDENTS_VIEW = 'students-view';
export const GROUP_VIEW = 'group-view';
